import { FAILED } from 'constants/data';
import { ERROR } from 'constants/dialogs';
import { TRANSACTION_SOMETHING_WENT_WRONG } from 'constants/dbetSDK';
import { RESTORE_LOGIN } from 'constants/messages/error';

import { SET_ERROR } from './actionTypes';
import { openDialog } from './dialog';
import { setHasRestoreLogin } from './auth';
import { setTransactionNotification } from './dbet';

export const setError = payload => async dispatch => {
  await dispatch({ type: SET_ERROR, payload });

  dispatch(openDialog(ERROR));
};

export const setTransactionError = payload => async dispatch => {
  const { errorId } = payload;

  if (errorId === RESTORE_LOGIN) {
    dispatch(setHasRestoreLogin(true));
  } else {
    dispatch(
      setTransactionNotification({
        type: TRANSACTION_SOMETHING_WENT_WRONG,
        status: FAILED,
      }),
    );
  }
};
